
import { api } from '@api'
import { Contact, PaginatedResponse } from './types'
import { Scope } from '@utils'
import { usePaginate } from './usePaginate'

interface FetchParams {
  pageParam?: string
  search?: string
  scope?: Scope[]
  filters?: any
}

const fetchSuggestedContacts = async ({
  pageParam = '1',
  search,
  scope,
  filters,
}: FetchParams): Promise<PaginatedResponse<Contact>> => {
  const queryParams = new URLSearchParams()
  queryParams.append('page', pageParam)
  if (search) queryParams.append('search', search)
  if (scope) queryParams.append('scope', String(scope))
  if (filters) queryParams.append('filters', JSON.stringify(filters))
  const url = `/suggested-contacts?${queryParams.toString()}`
  
  const { data } = await api.get<PaginatedResponse<Contact>>(url)
  return data
}

export const usePaginateSuggestedContacts = ({search, scope, filters}: {search?: string, scope?: Scope[], filters?: any}) => {
  return usePaginate<Contact>('suggested-contacts', fetchSuggestedContacts, {search, scope, filters})
}